<template>
  <div class="home">
    <h1 class="headline center">Work</h1>
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <div class="sections">
      <div
        v-for="(section, index) in Object.keys(entries)"
        :key="index"
        class="group"
      >
        <h2 class="left">
          {{ section }}
          <span class="projects-number">{{ entries[section].length }}</span>
        </h2>
        <div class="section" v-for="entry in entries[section]" :key="entry.id">
          <div class="entry">
            <div class="entry-date">{{ entry.date }}</div>
            <h3 @click="$router.push({ name: entry.id })">
              {{ entry.title }}
            </h3>
            <p>{{ entry.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WORKENTRIES from '@/statics/data/projects.json'

export default {
  name: 'IndexWork',
  computed: {
    entries() {
      return WORKENTRIES
    }
  }
}
</script>
<style lang="scss" scoped>
span.projects-number {
  font-size: 17px;
  vertical-align: top;
  margin-left: 10px;
  display: inline;
  line-height: 13px;
  top: 3px;
  position: relative;
}
.sections {
  max-width: 80vw !important;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(100px, auto);
  column-gap: 25px;
  row-gap: 1em;
}
.vuerollr img.is-active,
.vuerollr video.is-active {
  width: 100%;
}
.vr-container {
  max-width: 500px;
  height: 300px;
}
.vuerollr {
  width: 100%;
  height: 100%;
}
.center {
  text-align: center;
}
.headline {
  text-transform: uppercase;
  margin: 4rem auto;
  font-size: 4rem;
}
img {
  display: block;
  margin: 0 auto;
  width: 150px;
}

h3 {
  // color: #42b883;
  margin-bottom: 0;
  cursor: pointer;
  font-family: Roboto, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0.03125em;
  text-decoration: inherit;
  text-transform: inherit;
  color: #212121;
  margin: 0;
  letter-spacing: 0;
  text-decoration: underline;
  font-weight: bold;
  font-size: 1rem;
  &:hover {
    text-decoration: underline;
  }
}

.entry-date {
  font-family: 'Roboto Mono', monospace;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0;
  text-decoration: none;
  text-transform: uppercase;
  margin-top: 1.5rem;
  margin-bottom: 0.25rem;
  color: #616161;
  margin: 24px 16px 4px 0;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.25rem;
}

p {
  margin-top: 0.4rem;
}

.sections {
  max-width: 40vw;
  margin: 0 auto;
  margin-top: 4rem;
}

.section {
  margin-bottom: 3rem;
}

.group {
  margin-bottom: 4rem;
}
</style>
